import * as React from 'react';
import { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8.796 11.803A5.684 5.684 0 1 0 4.349 1.341a5.684 5.684 0 0 0 4.447 10.462ZM11 11l4 4"
        />
    </svg>
);
export default SvgSearch;
